module.exports = __webpack_public_path__ + "static/fonts/BMHANNA_11yrs.c064e45.ttf";